import React from 'react';

const Blog = () => {
    return (
        <div>
            <h3 className="text-justify mx-5 mt-5">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum soluta quis, cupiditate quibusdam incidunt obcaecati laboriosam nostrum numquam adipisci! Enim nobis autem aut in numquam voluptates ex excepturi modi rem obcaecati ipsa repudiandae id error, perspiciatis dolores quasi! Quisquam et recusandae accusantium adipisci hic nisi eligendi architecto nam dolores similique?</h3>
        </div>
    );
};

export default Blog;